exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#loginNext {\n  width: 252px;\n  margin-bottom: 33px;\n}", ""]);

// exports
